import images from "./images";

const Menu = [
  {
    text: "Services",
    link: "/#services",
  },
  {
    text: "Pricing",
    link: "/#pricing",
  },
  {
    text: "Process",
    link: "/#process",
  },
  {
    text: "Testimonials",
    link: "/#testimonials",
  },
  {
    text: "Request a quote",
    link: "/#quote",
  },
];

const ServicesData = [
  {
    titleone: "Search engine",
    titletwo: "optimization",
    link: "/search-engine-optimization",
    itemclass: "blight",
    imgURL: images.services01,
  },
  {
    titleone: "Web Design &",
    titletwo: "Web Development",
    link: "/web-design-and-web-development",
    itemclass: "bgreen",
    imgURL: images.services02,
  },
  {
    titleone: "Social Media",
    titletwo: "Marketing",
    link: "/social-media-marketing",
    itemclass: "bdark",
    imgURL: images.services03,
  },
  {
    titleone: "Email",
    titletwo: "Marketing",
    link: "/email-marketing",
    itemclass: "blight",
    imgURL: images.services04,
  },
  {
    titleone: "Lead",
    titletwo: "Generation",
    link: "/lead-generation",
    itemclass: "bgreen",
    imgURL: images.services05,
  },
  {
    titleone: "Ads",
    titletwo: "Management",
    link: "/ads-management",
    itemclass: "bdark",
    imgURL: images.services06,
  },
];

const CaseStudies = [
  {
    text: "We migrated a small-studio website from WordPress to React — improving load times and user experience which resulted in higher engagement.",
    link: "#",
  },
  {
    text: "Designed a responsive multipage site for an interior studio to showcase portfolio work and improve conversion paths.",
    link: "#",
  },
  {
    text: "Developed a modern React site for a management firm to highlight achievements and services, increasing lead enquiries.",
    link: "#",
  },
];

const WorkingProcess = [
  {
    title: "Consultation",
    description:
      "During the initial consultation we discuss your goals, audience, and current marketing to tailor a plan that fits your needs.",
  },
  {
    title: "Research and Strategy Development",
    description:
      "We research your industry and competitors, identify opportunities, and create a focused roadmap designed to deliver results.",
  },
  {
    title: "Implementation",
    description:
      "With strategy in place we execute: design, development, content, and campaigns — all engineered to meet your objectives.",
  },
  {
    title: "Monitoring and Optimization",
    description:
      "We continuously monitor performance and refine campaigns and site elements to maximise ROI and user satisfaction.",
  },
  {
    title: "Reporting and Communication",
    description:
      "You’ll receive regular reports with actionable insights and we keep communication open so you're always in the loop.",
  },
  {
    title: "Continual Improvement",
    description:
      "We treat every engagement as ongoing — iterating on what works and adapting to market changes for sustained growth.",
  },
];

const Team = [
  {
    name: "Struggling to reach your target audience?",
    info: "Finding the right marketing strategy can be tough. With years of experience in digital marketing, we’ll help you reach your audience and grow your business.",
  },
  {
    name: "Unsure About Your Marketing ROI?",
    info: "Investing in marketing should return measurable results. We help you track ROI and make data-driven decisions to improve performance.",
  },
  {
    name: "Website Not Working for You?",
    info: "Is your website attracting the right visitors and guiding them to convert? We optimise sites to turn visitors into leads and customers.",
  },
];

const Testimonials = [
  {
    name: "Srinivas",
    position: "Local Studio",
    testimonial:
      "Quantech transformed our website to a modern React build. Site speed improved and user experience got a major uplift — we saw a clear increase in enquiries.",
  },
  {
    name: "Suresh Kolkar",
    position: "Design Studio",
    testimonial:
      "The new responsive site showcased our portfolio beautifully. Smooth transitions and SEO improvements led to better engagement and more client contacts.",
  },
  {
    name: "M S Karthik",
    position: "Management Firm",
    testimonial:
      "Quantech built a professional site that highlighted our achievements. Our online visibility improved and we received more qualified leads.",
  },
];

const DyanmicPages = [
  {
    slug: "email-marketing",
    title: "Email Marketing: Boost Engagement & Drive Conversions",
    content:
      "Email marketing is a powerful direct channel to engage your audience. Strategic, data-driven campaigns build relationships, nurture leads, and drive sales.",
    image: images.email,
    paragraphs: [
      {
        content:
          "Email remains a core marketing tool for businesses. Personalised campaigns, segmentation and automation let you reach the right people at the right time.",
      },
      {
        content:
          "Analytics from email campaigns provide deep insight into customer behavior, helping refine messaging and improve conversion rates.",
      },
      {
        content:
          "At Quantech we create measurable email programs focused on engagement, deliverability and ROI — from welcome flows to re-engagement sequences.",
      },
    ],
  },
  {
    slug: "search-engine-optimization",
    title: "Search Engine Optimization: Improve Visibility & Traffic",
    content:
      "Effective SEO increases organic visibility and attracts relevant visitors who are more likely to convert. We focus on technical health, content and user experience.",
    image: images.seo,
    paragraphs: [
      {
        content:
          "Quantech builds SEO strategies tailored to your market — focusing on on-page optimization, technical fixes, and content that ranks and converts.",
      },
    ],
  },
  {
    slug: "web-design-and-web-development",
    title: "Web Design & Development: Create Stunning Online Experiences",
    content:
      "A well-designed website attracts visitors and converts them into customers. We blend design and performance to create beautiful, usable sites.",
    image: images.webDesign,
    paragraphs: [
      {
        content:
          "We craft bespoke websites tailored to your brand and audience — responsive, fast, and built to help you achieve measurable goals.",
      },
    ],
  },
  {
    slug: "social-media-marketing",
    title: "Social Media Marketing: Engage Your Audience & Drive Growth",
    content:
      "Social media helps build brand awareness and nurture customer relationships. We design strategies and content that grow engagement and leads.",
    image: images.socialMedia,
    paragraphs: [
      {
        content:
          "From content calendars to community management and analytics, Quantech helps you use social platforms to reach and convert your target customers.",
      },
    ],
  },
  {
    slug: "lead-generation",
    title: "Lead Generation: Fuel Your Sales Pipeline",
    content:
      "We design campaigns and funnels that attract qualified leads and feed your sales pipeline with opportunities that convert.",
    image: images.leadGeneration,
    paragraphs: [
      {
        content:
          "Using paid media, organic tactics and landing page optimisation, we create predictable lead flows tailored to your budget and goals.",
      },
    ],
  },
  {
    slug: "ads-management",
    title: "Ads Management: Data-Driven Campaigns that Convert",
    content:
      "Analytics and tracking are central to ads that perform. We set up measurement, test creative and optimise bids to maximise return.",
    image: images.analytics,
    paragraphs: [
      {
        content:
          "At Quantech we combine creative, data and testing to run effective campaigns across search and social — focusing on measurable outcomes.",
      },
    ],
  },
];

export default {
  Menu,
  CaseStudies,
  WorkingProcess,
  Team,
  Testimonials,
  ServicesData,
  DyanmicPages,
};